// extracted by mini-css-extract-plugin
export default {"loader":"WithLoader_loader","hidden":"WithLoader_hidden"};